import React from "react";
import { render } from "react-dom";
import Highcharts from "highcharts/highstock";
import highchartsMore from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";

highchartsMore(Highcharts);

const options = {
  

  chart: {
    type: 'column',
    inverted: true,
    polar: true,
   
},
title: {
    text: 'Custom start and end angles of pane'
},
// subtitle: {
//     text: 'The startAngle <b>(45)</b> and endAngle <b>(315)</b>'
// },
tooltip: {
  // outside: true
},
pane: {
    size: '95%',
    innerSize: '20%',
    endAngle: 270
    // startAngle: 0,
    // endAngle: 275
},
xAxis: {
    tickInterval: 3,
    labels: {
        allowOverlap: true,
        y: -5,
        align: 'right',
            useHTML: true,
            allowOverlap: true,
            step: 1,
            y: 3,
            style: {
                fontSize: '13px'
            }
    }
},
yAxis: {
  crosshair: {
    enabled: true,
    color: '#333'
},
    lineWidth: 0,
    tickInterval: 25,
    reversedStacks: false,
    endOnTick: true,
    max: 200,
    showLastLabel: true
},
plotOptions: {
    series: {
        pointPadding: 0,
        groupPadding: 0,
        dataLabels: {
            enabled: true,
            inside: true,
            allowOverlap: true
        }
        
    }
},
series: [{
    colorByPoint: true,
    data: [29, 71, 106, 129, 144, 176, 135, 148, 216, 194, 95, 94]
}]









  // title: {
  //   text: "My stock chart"
  // },
  // series: [
  //   {
  //     data: [1, 2, 1, 4, 3, 6, 7, 3, 8, 6, 9]
  //   }
  // ]
}


const Sample2 = () => (
  <div id="container">
    <HighchartsReact
      highcharts={Highcharts}
      constructorType={"stockChart"}
      options={options}
    />
  </div>
);

export default Sample2
